import {staticFile} from 'remotion';
import type {VideoCommentaryHighlightProps} from '../templates/custom/video-commentary-highlight';

export const videoCommentaryHighlightDatasets: Record<
  string,
  VideoCommentaryHighlightProps
> = {
  requestLocal: {
    backgroundVideo: {
      url: staticFile('debug/request-background-video.mp4'),
    },
    backgroundAudio: {
      url: staticFile('debug/request-background-audio.mp3'),
    },
    comments: [
      {
        audioStartTime: 0,
        audioEndTime: 30,
        videoStartTime: 0,
        videoEndTime: 10,
      },
      {
        audioStartTime: 30,
        audioEndTime: 46,
        videoStartTime: 10,
        videoEndTime: 15,
      },
    ],
    highlights: [
      {
        type: 'rectangle',
        audioStartTime: 7,
        audioEndTime: 14,
        videoStartTime: 8,
        videoEndTime: 8,
        position: {
          x: 180,
          y: 180,
          width: 520,
          height: 280,
        },
        borderWidth: 8,
        borderColor: '#f52e2e',
        borderRadius: 20,
      },
      {
        type: 'arrow',
        audioStartTime: 35,
        audioEndTime: 42,
        videoStartTime: 12,
        videoEndTime: 12,
        position: {
          x: 231,
          y: 200,
          width: 264,
          height: 110,
        },
        rotation: 44.66457880943479,
        borderColor: '#ff0000',
      },
      {
        type: 'freeze',
        audioStartTime: 43,
        audioEndTime: 46,
        videoStartTime: 14,
        videoEndTime: 14,
      },
      {
        type: 'circle',
        audioStartTime: 43,
        audioEndTime: 46,
        videoStartTime: 14,
        videoEndTime: 14,
        position: {
          x: 280,
          y: 110,
          width: 520,
          height: 300,
        },
        borderWidth: 8,
        borderColor: '#ff0000',
        fadeIn: 0.15,
        fadeOut: 0.15,
      },
    ],
    voiceVolume: 100,
    originalVolume: 5,
    defaultFadeIn: 0.15,
    defaultFadeOut: 0.15,
  },
  requestAutoZoom: {
    backgroundVideo: {
      url: staticFile('auto-zoom-debug/request-background-video.mp4'),
    },
    backgroundAudio: {
      url: staticFile('auto-zoom-debug/request-background-audio.mp3'),
    },
    comments: [
      {
        audioStartTime: 0.11,
        audioEndTime: 35.189,
        videoStartTime: 0,
        videoEndTime: 11,
      },
    ],
    highlights: [
      {
        type: 'focus-area',
        audioStartTime: 2.63,
        audioEndTime: 11.389,
        videoStartTime: 0.495608,
        videoEndTime: 0.495608,
        position: {
          x: 390,
          y: 282,
          width: 322,
          height: 277,
        },
        borderWidth: 8,
        borderColor: '#ff0000',
        borderRadius: 0,
        rotation: 0,
        fadeIn: 0.8,
        fadeOut: 0.8,
        zoomScale: 1,
        easingType: 'ease-in-out',
      },
      {
        type: 'circle',
        audioStartTime: 16.31,
        audioEndTime: 16.68,
        videoStartTime: 3,
        videoEndTime: 3,
        position: {
          x: 87,
          y: 8,
          width: 943,
          height: 559,
        },
        borderWidth: 8,
        borderColor: '#ff0000',
        borderRadius: 280,
        rotation: 0,
        fadeIn: 0.3,
        fadeOut: 0.3,
        zoomScale: 1,
        easingType: 'ease-in-out',
      },
      {
        type: 'arrow',
        audioStartTime: 24.56,
        audioEndTime: 24.9,
        videoStartTime: 7,
        videoEndTime: 7,
        position: {
          x: 0,
          y: 257,
          width: 523,
          height: 119,
        },
        borderWidth: 8,
        borderColor: '#ff0000',
        borderRadius: 0,
        rotation: 117.3227097594747,
        fadeIn: 0.3,
        fadeOut: 0.3,
        zoomScale: 1,
        easingType: 'ease-in-out',
      },
      {
        type: 'rectangle',
        audioStartTime: 30.83,
        audioEndTime: 31.209,
        videoStartTime: 11,
        videoEndTime: 11,
        position: {
          x: 290,
          y: 310,
          width: 404,
          height: 252,
        },
        borderWidth: 8,
        borderColor: '#ff0000',
        borderRadius: 0,
        rotation: 0,
        fadeIn: 0.3,
        fadeOut: 0.3,
        zoomScale: 1,
        easingType: 'ease-in-out',
      },
    ],
    voiceVolume: 100,
    originalVolume: 5,
    defaultFadeIn: 0,
    defaultFadeOut: 0,
  },
};

export const defaultVideoCommentaryHighlightProps: VideoCommentaryHighlightProps =
  videoCommentaryHighlightDatasets.requestAutoZoom;
